export default "__VITE_ASSET__Cw5rzx03__"